module.exports = __webpack_public_path__ + "static/media/left_arrow.1b2e21bb.svg";